/**
 * Squared M1NT button, same as the buttons on the M1NT website.
 * `solid` is the single primary call to action on a page: white fill on the black ground.
 */
export function M1ntButton({
  as: Tag = 'button',
  type,
  solid = false,
  className = '',
  children,
  ...rest
}) {
  const props = Tag === 'button' ? { type: type || 'button', ...rest } : rest
  const look = solid
    ? 'border border-white bg-white text-m1-ground hover:bg-[#e4e4e4] hover:border-[#e4e4e4] disabled:hover:bg-white disabled:hover:border-white'
    : 'border border-white/30 text-m1-ink hover:border-m1-violet hover:text-m1-violet disabled:hover:border-white/30 disabled:hover:text-m1-ink'
  return (
    <Tag
      {...props}
      className={`inline-flex min-h-[44px] items-center justify-center gap-2 px-5 text-[14px] tracking-[0.04em] transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${look} ${className}`}
    >
      {children}
    </Tag>
  )
}

const NOTICE_TONES = {
  amber: 'border-m1-amber/35 bg-m1-amber/10 text-m1-ink-soft',
  violet: 'border-m1-violet/35 bg-m1-violet/10 text-m1-ink-soft',
  neutral: 'border-m1-line bg-m1-surface text-m1-ink-soft',
}

/** Rounded plate for notices, matching the plates used on the M1NT site. */
export function M1ntNotice({ tone = 'neutral', className = '', children, ...rest }) {
  return (
    <div
      {...rest}
      className={`rounded-2xl border p-4 text-[15px] font-light leading-relaxed sm:p-5 ${NOTICE_TONES[tone] || NOTICE_TONES.neutral} ${className}`}
    >
      {children}
    </div>
  )
}

/** Class names for text inputs on M1NT pages (squared, hairline border, violet focus). */
export const M1NT_INPUT_CLASS =
  'min-h-[48px] w-full border border-m1-line bg-transparent px-4 py-3 text-[16px] font-light text-m1-ink placeholder:text-m1-muted focus:border-m1-violet focus:outline-none disabled:opacity-50'

/** Small muted label shown above a field or value. */
export const M1NT_LABEL_CLASS = 'mb-2 block text-[14px] text-m1-muted'
